import React from 'react';
import { Modal, Form } from 'react-bootstrap';

interface GroupFormData {
    name: string;
    description: string;
}

interface NewGroupModalProps {
    isOpen: boolean;
    onClose: () => void;
    formData: GroupFormData;
    setFormData: React.Dispatch<React.SetStateAction<GroupFormData>>;
    selectedGroup: any | null;
    onSubmit: () => Promise<void>;
    isLoading: boolean;
}

const NewGroupModal: React.FC<NewGroupModalProps> = ({
                                                         isOpen,
                                                         onClose,
                                                         formData,
                                                         setFormData,
                                                         selectedGroup,
                                                         onSubmit,
                                                         isLoading
                                                     }) => {
    return (
        <Modal show={isOpen} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {selectedGroup ? 'Edit Group' : 'Create New Group'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.name}
                            onChange={(e) => setFormData(prev => ({
                                ...prev,
                                name: e.target.value
                            }))}
                            placeholder="Enter group name"
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={formData.description}
                            onChange={(e) => setFormData(prev => ({
                                ...prev,
                                description: e.target.value
                            }))}
                            placeholder="Enter group description"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onSubmit}
                    disabled={!formData.name || isLoading}
                >
                    {isLoading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status"/>
                            Loading...
                        </>
                    ) : (
                        <>{selectedGroup ? 'Update' : 'Create'} Group</>
                    )}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default NewGroupModal;